<h1 mat-dialog-title>HIT PIN &auml;ndern</h1>
<div mat-dialog-content>
    <mat-hint style="font-size: 0.8em">
        <strong>Hinweis:</strong> Die Änderung der PIN dient zur Nacherfassung in VetVet, nachdem die PIN im HIT-Portal
        geändert wurde. Das Ändern der PIN hat keine Auswirkungen auf die PIN im HIT-Portal.
        <br />
        <br />
        Die Nacherfassung ist notwendig, um über VetVet mit der neuen PIN Meldungen an das HIT-Portal zu senden.
    </mat-hint>

    <div style="padding-top: 24px">
        <mat-form-field style="width: 100%">
            <mat-label>PIN</mat-label>
            <input matInput [type]="showPasswort ? 'text' : 'password'" [formControl]="neuePinCtrl" placeholder="PIN" />
            <button mat-icon-button matSuffix (click)="showPasswort = !showPasswort">
                <mat-icon>{{ showPasswort ? "visibility" : "visibility_off" }} </mat-icon>
            </button>
            <mat-error *ngIf="neuePinCtrl.hasError('required')">Es muss eine PIN eingegeben werden.</mat-error>
            <mat-error *ngIf="neuePinWdhCtrl.hasError('not-matching')"></mat-error>
        </mat-form-field>

        <mat-form-field style="width: 100%">
            <mat-label>PIN wiederholen</mat-label>
            <input
                matInput
                [type]="showPasswort ? 'text' : 'password'"
                [formControl]="neuePinWdhCtrl"
                placeholder="PIN"
            />
            <button mat-icon-button matSuffix (click)="showPasswort = !showPasswort">
                <mat-icon>{{ showPasswort ? "visibility" : "visibility_off" }} </mat-icon>
            </button>
            <mat-error *ngIf="neuePinWdhCtrl.hasError('required')">Es muss eine PIN eingegeben werden.</mat-error>
            <mat-error *ngIf="neuePinWdhCtrl.hasError('not-matching')"
                >Die eingebenen PINs stimmen nicht überein.
            </mat-error>
        </mat-form-field>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Abbrechen</button>
    <button mat-flat-button color="accent" (click)="pinAendern()" [disabled]="!kunde || isSaving"> PIN ändern </button>
</div>
